import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const ServiceTypesDetails = lazy(
  () => import('@/containers/Views/ServiceTypes/ServiceTypesPage'),
);

const ServiceTypesRouter = (
  <Route path="service_types">
    <Route
      index
      element={(
        <PrivateRoute pageName={EPage.ServiceTypes} permissions={EBasicActions.Find}>
          <ServiceTypesDetails />
        </PrivateRoute>
      )}
    />
  </Route>
);
export default ServiceTypesRouter;
